import {VStack} from "@chakra-ui/react";
import {useState} from "react";
import ChatFrame from "@/components/ui/chat/ChatFrame";
import ChatTab from "@/components/ui/chat/ChatTab";
import {useChat} from "@/components/providers/ChatProvider";

const ChatContainer = ({chat, onClose, onSendMessage}) => {
    const [collapsed, setCollapsed] = useState(false);
    const [isSending, setIsSending] = useState(false); // Renamed from initial isSending to control UI elements state
    const { streamingState } = useChat();

    const handleOnSendMessage = (message) => {
        setIsSending(true); // Set sending to true when message is sent
        if (onSendMessage) {
            onSendMessage(message, chat.id);
        }
        setIsSending(false); // Set sending to false after message is sent (or response received if async)
    }

    const handleOnClose = () => {
        onClose && onClose(chat.id);
    }

    const onWhatsupNo = () => {

    }

    return (
           <VStack w={470}>
                <VStack w={'full'} display={collapsed ? 'flex' : 'none'}>
                   <ChatTab chat={chat} onPress={() => setCollapsed(false)} />
                </VStack>
               <VStack w={'full'} display={collapsed ? 'none' : 'flex'}>
                   <ChatFrame
                       chat={chat}
                       onMinimalizeClick={() => setCollapsed(true)}
                       onCloseClick={handleOnClose}
                       onSendMessage={handleOnSendMessage}
                       isSending={isSending}
                       streamingState={streamingState}
                       onWhatsUpNo={onWhatsupNo}
                   />
                </VStack>
           </VStack>
    )
}

export default ChatContainer;